import React, { useState, useEffect } from 'react';
import axios from 'services/axios_config';
import cloneDeep from 'lodash/cloneDeep';
export const TransformContext = React.createContext();

const TransformContextProvider = ({ children }) => {
    const defaultFormulaItems = [];
    const [formulaItems, setFormulaItems] = useState(defaultFormulaItems);
    const [formulaItemsHistory, setFormulaItemsHistory] = useState([]);

    const setFormulaHistory = (newFormulaItem) => {
        let items = cloneDeep(formulaItemsHistory);
        items.push(newFormulaItem);

        if (items != undefined && items.length > 20) {
            items.shift();
        }
        setFormulaItemsHistory(items);
    };

    const getFormulaHistory = () => {
        let items = cloneDeep(formulaItemsHistory);
        items.pop();
        setFormulaItemsHistory(items);
        items = cloneDeep(items);
        let prevState = items.pop();

        return prevState != undefined ? prevState : [];
    };

    const transformSettings = {
        formulaItems: formulaItems,
        setFormulaItems,
        setFormulaHistory,
        getFormulaHistory
    };

    return (
        <>
            <TransformContext.Provider value={transformSettings}>
                {children}
            </TransformContext.Provider>
        </>
    );
};

export default TransformContextProvider;
